module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/play-900d357720e35fe812bf2a2561116cb8.svg";